import React from "react";
import { useLocation } from "react-router-dom";
import "./AboutSec3.css";

// IMPORT ENGLISH DATA
import {
  aboutData,
  financialStatementAuditData,
  ifrsAdvisoryServiceData,
  otherAssuranceServiceData,
  internalControlFrameworkData,
  dealAdvisoryData,
  restructuringData,
  dueDiligenceData,
  forensicServicesData,
  riskAdvisoryData,
  technologyAdvisoryServiceData,
  valuationsData,
  corporateTaxData,
  mergerAndAcquisitionData,
  transferPricingData,
  valueAddedTaxData,
  internationalTaxData,
  exciseTaxData,
  taxRestructuringData,
  economicSubstanceRegulationsData,
  financeAndAccountingData,
  corporateAdvisoryServicesData,
  expensesClaimManagementData,
  payrollHrServicesData,
  secondmentData,
  treasuryServiceData,
  marketResearchData,
  businessConsultingData,
  entitySetupData,
  outsourcedFinanceRegulatoryComplianceData,
  companySecretarialData,
} from "../../../Data/AboutSec3Data";

// IMPORT FRENCH DATA
import {
  aboutDataFR,
  financialStatementAuditDataFR,
  ifrsAdvisoryServiceDataFR,
  otherAssuranceServiceDataFR,
  internalControlFrameworkDataFR,
  dealAdvisoryDataFR,
  restructuringDataFR,
  dueDiligenceDataFR,
  forensicServicesDataFR,
  riskAdvisoryDataFR,
  technologyAdvisoryServiceDataFR,
  valuationsDataFR,
  corporateTaxDataFR,
  mergerAndAcquisitionDataFR,
  transferPricingDataFR,
  valueAddedTaxDataFR,
  internationalTaxDataFR,
  exciseTaxDataFR,
  taxRestructuringDataFR,
  economicSubstanceRegulationsDataFR,
  financeAndAccountingDataFR,
  corporateAdvisoryServicesDataFR,
  expensesClaimManagementDataFR,
  payrollHrServicesDataFR,
  secondmentDataFR,
  treasuryServiceDataFR,
  marketResearchDataFR,
  businessConsultingDataFR,
  entitySetupDataFR,
  outsourcedFinanceRegulatoryComplianceDataFR,
  companySecretarialDataFR,
} from "../../../Data/French/AboutSec3DataFR";

export default function AboutSec3({ currentLanguage = "en" }) {
  const location = useLocation();
  const path = location.pathname;
  
  const isFrench = currentLanguage === "fr";

  // Default data
  let data = isFrench ? aboutDataFR : aboutData;

  // AUDIT + ASSURANCE
  if (path === "/services/auditandassurance/financialstatementaudit") {
    data = isFrench ? financialStatementAuditDataFR : financialStatementAuditData;
  } else if (path === "/services/auditandassurance/ifrsadvisoryservice") {
    data = isFrench ? ifrsAdvisoryServiceDataFR : ifrsAdvisoryServiceData;
  } else if (path === "/services/auditandassurance/otherassuranceservice") {
    data = isFrench ? otherAssuranceServiceDataFR : otherAssuranceServiceData;
  } else if (path === "/services/auditandassurance/internalcontrolframework") {
    data = isFrench ? internalControlFrameworkDataFR : internalControlFrameworkData;
  }

  // ADVISORY
  else if (path === "/services/advisory/dealadvisory") {
    data = isFrench ? dealAdvisoryDataFR : dealAdvisoryData;
  } else if (path === "/services/advisory/restructuring") {
    data = isFrench ? restructuringDataFR : restructuringData;
  } else if (path === "/services/advisory/duediligence") {
    data = isFrench ? dueDiligenceDataFR : dueDiligenceData;
  } else if (path === "/services/advisory/forensicservices") {
    data = isFrench ? forensicServicesDataFR : forensicServicesData;
  } else if (path === "/services/advisory/riskadvisory") {
    data = isFrench ? riskAdvisoryDataFR : riskAdvisoryData;
  } else if (path === "/services/advisory/technologyadvisoryservice") {
    data = isFrench ? technologyAdvisoryServiceDataFR : technologyAdvisoryServiceData;
  } else if (path === "/services/advisory/valuations") {
    data = isFrench ? valuationsDataFR : valuationsData;
  }

  // TAXATION
  else if (path === "/services/taxation/corporatetax") {
    data = isFrench ? corporateTaxDataFR : corporateTaxData;
  } else if (path === "/services/taxation/mergerandacquisition") {
    data = isFrench ? mergerAndAcquisitionDataFR : mergerAndAcquisitionData;
  } else if (path === "/services/taxation/transferpricing") {
    data = isFrench ? transferPricingDataFR : transferPricingData;
  } else if (path === "/services/taxation/valueaddedtax") {
    data = isFrench ? valueAddedTaxDataFR : valueAddedTaxData;
  } else if (path === "/services/taxation/internationaltax") {
    data = isFrench ? internationalTaxDataFR : internationalTaxData;
  } else if (path === "/services/taxation/excisetax") {
    data = isFrench ? exciseTaxDataFR : exciseTaxData;
  } else if (path === "/services/taxation/taxrestructuring") {
    data = isFrench ? taxRestructuringDataFR : taxRestructuringData;
  } else if (path === "/services/taxation/economicsubstanceregulations") {
    data = isFrench ? economicSubstanceRegulationsDataFR : economicSubstanceRegulationsData;
  }

  // BPO
  else if (path === "/services/businessserviceoutsourcing/financeandaccounting") {
    data = isFrench ? financeAndAccountingDataFR : financeAndAccountingData;
  } else if (path === "/services/businessserviceoutsourcing/corporateadvisoryservices") {
    data = isFrench ? corporateAdvisoryServicesDataFR : corporateAdvisoryServicesData;
  } else if (path === "/services/businessserviceoutsourcing/expensesclaimmanagement") {
    data = isFrench ? expensesClaimManagementDataFR : expensesClaimManagementData;
  } else if (path === "/services/businessserviceoutsourcing/payrollhrservices") {
    data = isFrench ? payrollHrServicesDataFR : payrollHrServicesData;
  } else if (path === "/services/businessserviceoutsourcing/secondment") {
    data = isFrench ? secondmentDataFR : secondmentData;
  } else if (path === "/services/businessserviceoutsourcing/treasuryservice") {
    data = isFrench ? treasuryServiceDataFR : treasuryServiceData;
  }

  // STRATEGIES
  else if (path === "/services/strategies/marketresearch") {
    data = isFrench ? marketResearchDataFR : marketResearchData;
  } else if (path === "/services/strategies/businessconsulting") {
    data = isFrench ? businessConsultingDataFR : businessConsultingData;
  }

  // CORPORATE SERVICES
  else if (path === "/services/corporateservices/entitysetup") {
    data = isFrench ? entitySetupDataFR : entitySetupData;
  } else if (path === "/services/corporateservices/outsourcedfinanceregulatorycompliance") {
    data = isFrench ? outsourcedFinanceRegulatoryComplianceDataFR : outsourcedFinanceRegulatoryComplianceData;
  } else if (path === "/services/corporateservices/companysecertarial") {
    data = isFrench ? companySecretarialDataFR : companySecretarialData;
  }

  const isServicesPage = path.startsWith("/services");

  return (
    <div className="aboutsec3-main section">
      <div className={`${isServicesPage ? "serviceaboutsec3-top" : "aboutsec3-top"}`}>
        <div className="row align-items-center">
          <div className={`${isServicesPage ? "col-md-12" : "col-md-6"} aboutsec3-left`}>
            <div className="d-flex align-items-center">
              <div className="services-line me-3"></div>
              <p
                className="service-subtitle mb-0"
                dangerouslySetInnerHTML={{ __html: data.subtitle }}
              ></p>
            </div>

            <h2
              className="service-title"
              dangerouslySetInnerHTML={{ __html: data.title }}
            ></h2>
          </div>

          {!isServicesPage && (
            <div className="col-md-6 aboutsec3-right">
              <p className="mt-4">{data.rightText}</p>
            </div>
          )}
        </div>
      </div>

      <div className="bottom-section">
        <div className="aboutsec3-boxes">
          <div className="aboutsec3-box-line"></div>

          <div className="aboutsec3-box">
            <h5 className="aboutsec3-box-title">{data.box1Title}</h5>
            <p className="aboutsec3-box-text">{data.box1Text}</p>
          </div>

          <div className="aboutsec3-box-line"></div>

          <div className="aboutsec3-box">
            <h5 className="aboutsec3-box-title">{data.box2Title}</h5>
            <p className="aboutsec3-box-text">{data.box2Text}</p>
          </div>
        </div>

        <div className="aboutsec3-image-wrapper">
          <img src={data.image} alt="Service Graphic" className="aboutsec3-image" />
        </div>
      </div>
    </div>
  );
}